module.exports = __webpack_public_path__ + "img/wechat-hint.0e766854.png";